const STATUS = Object.freeze({
  PENDING_LIQUIDATION: "PNL",
  LIQUIDATED: "LIQ",
  CANCELLED: "CAN",
});

export default Object.freeze({
  STATUS: STATUS,
});
